module.exports = __webpack_public_path__ + "img/cajas.4c321d6c.png";